export const getFileNameFromUrlOrObj = (f) => {
    if (!f) return null
    if (f.file_name) return String(f.file_name)
    if (f.name && String(f.name).includes('.')) return String(f.name)
    const url = f.url || (f.response && f.response.url)
    if (!url) return null
    try {
        const pathname = new URL(url).pathname
        const name = decodeURIComponent(pathname.split('/').pop() || '')
        return name || null
    } catch (e) {
        const m = String(url).match(/\/([^\/?#]+)(?:[?#].*)?$/)
        return m ? decodeURIComponent(m[1]) : null
    }
}

export const createFileListFromServer = (serverFiles = {}, isReuse = false, barcodeItem = '', extDefault = '.dst') => {
    return Object.entries(serverFiles).reduce((acc, [side, files]) => {
        acc[side] = Array.isArray(files) && files.length > 0 ? (files || []).map((fileObj, idx) => {
            const { file_name = '', url = '' } = fileObj || {}

            // Nếu không có file_name thì lấy từ url
            const originalName = file_name || (() => {
                const m = url.match(/\/([^\/?#]+\.dst)(?:[?#].*)?$/i)
                return m ? decodeURIComponent(m[1]) : `file_${side}_${idx}${extDefault}`
            })()
            const extMatch = originalName.match(/(\.[^.?#]+)(?:[?#].*)?$/)
            const ext = extMatch ? extMatch[1] : extDefault
            const sideSlug = String(side).replace(/\s+/g, '_')

            // nếu isReuse true và barcodeItem có giá trị -> tạo tên mới để hiển thị / download
            const displayName = isReuse && barcodeItem
                ? `${barcodeItem}_${sideSlug}${idx ? ` (${idx})` : ''}${ext}`
                : originalName

            return {
                uid: `emb-${side.replace(/\s+/g, '_')}-${idx}-${Date.now()}`,
                name: displayName,
                status: 'done',
                url,
            }
        }) : []
        return acc
    }, {})
}

export const createImageListFromServer = (serverFiles = {}) => {
    return Object.entries(serverFiles).reduce((acc, [side, files]) => {
        acc[side] = Array.isArray(files) && files.length > 0 ? (files || []).map((fileObj, idx) => {
            const { file_name = '', url = '' } = fileObj || {}
            return {
                uid: `emb-${side.replace(/\s+/g, '_')}-${idx}-${Date.now()}`,
                name: file_name,
                status: 'done',
                url,
            }
        }) : []
        return acc
    }, {})
}

export const buildEmptyListColor = (embroidery_sides = [], sideActive = [], status = '') => {
    return {
        ...embroidery_sides.reduce((acc, pos) => {
            acc[pos] = (sideActive.includes(pos) && status === "pending") ? ['', '', '', '', ''] : []
            return acc
        }, {})
    }
}

export const normalizeServerFiles = (serverFiles = {}) => {
    return Object.fromEntries(
        Object.entries(serverFiles || {}).map(([side, arr]) => {
            const list = Array.isArray(arr) ? arr.map(f => {
                const fn = getFileNameFromUrlOrObj(f) || ''
                return { file_name: fn, url: f.url || '' }
            }).filter(x => x.file_name || x.url) : []
            return [side, list]
        })
    )
}

export const extractUrlsAndNamesFromUI = (listObj = {}) => {
    return Object.fromEntries(
        Object.entries(listObj || {}).map(([side, arr]) => {
            const urls = []
            const names = []
            if (Array.isArray(arr)) {
                arr.forEach(f => {
                    if (!f) return
                    if (f.url) urls.push(f.url)
                    const n = getFileNameFromUrlOrObj(f)
                    if (n) names.push(n)
                })
            }
            return [side, { urls: Array.from(new Set(urls)), names: Array.from(new Set(names)) }]
        })
    )
}

export const pickLastN = (arr = [], n = 0) => {
    if (!Array.isArray(arr) || n <= 0) return []
    if (arr.length <= n) return arr.slice().map(f => ({ file_name: getFileNameFromUrlOrObj(f) || f.file_name || f.name || '', url: f.url || '' }))
    return arr.slice(-n).map(f => ({ file_name: getFileNameFromUrlOrObj(f) || f.file_name || f.name || '', url: f.url || '' }))
}

// Generic merge final files for either embroidery or color files
export const mergeFinalFilesForField = ({
    existingServer = {},
    uploadedResponse = {},
    currentUI = {},
    uploadCounts = {},
    embroidery_positions = []
}) => {
    const final = {}
    const sides = new Set([
        ...Object.keys(existingServer || {}),
        ...Object.keys(uploadedResponse || {}),
        ...Object.keys(currentUI || {}),
        ...Object.keys(uploadCounts || {})
    ])
    sides.forEach(side => {
        const existArr = Array.isArray(existingServer[side]) ? existingServer[side].slice() : []
        const uiInfo = currentUI[side] || { urls: [], names: [] }
        const uiUrlsSet = new Set(uiInfo.urls || [])
        const uiNamesSet = new Set(uiInfo.names || [])

        const keptExisting = existArr.filter(f => {
            if (f.url && uiUrlsSet.has(f.url)) return true
            if (f.file_name && uiNamesSet.has(f.file_name)) return true
            return false
        })

        const newCount = parseInt(uploadCounts[side] || 0, 10)
        const uploadedArrRaw = Array.isArray(uploadedResponse[side]) ? uploadedResponse[side] : []
        const newUploaded = pickLastN(uploadedArrRaw, newCount)

        const existingUrls = new Set(keptExisting.map(f => f.url).filter(Boolean))
        const existingNames = new Set(keptExisting.map(f => f.file_name).filter(Boolean))

        const toAdd = newUploaded.filter(f => {
            if (!f) return false
            if (f.url && existingUrls.has(f.url)) return false
            if (f.file_name && existingNames.has(f.file_name)) return false
            return true
        }).map(f => ({ file_name: f.file_name || '', url: f.url || '' }))

        const merged = [...keptExisting, ...toAdd].map(f => ({ file_name: f.file_name || '', url: f.url || '' }))

        if (merged.length && (Array.isArray(embroidery_positions) ? embroidery_positions.includes(side) : true)) {
            final[side] = merged
        }
    })
    return final
}

export const countEmbroideryLocations = (sides, firstNamePosition, firstEmbroideryPosition) => {
    if (!(Array.isArray(sides) && sides.length)) return
    
    const { name: fisrtSideName = '' } = Object.assign({}, firstEmbroideryPosition)
    const listSides = sides.filter(side => ![firstNamePosition, fisrtSideName].includes(side)) || []
    const lowercaseSides = listSides.map(side => side.toLowerCase()) || []

    const blinkSidebow = lowercaseSides.filter(side =>
        (side.includes("right hem_blink") || side.includes("left hem_blink"))
    ) || []

    const normalSidebow = lowercaseSides.filter(side =>
        (side.includes("right hem") || side.includes("left hem")) &&
        !side.includes("_blink")
    ) || []

    const reBlinkEmbroideryLocation = lowercaseSides.filter(side =>
        side.includes("_blink") &&
        !blinkSidebow.includes(side)
    ) || []

    const reNormalEmbroideryLocation = lowercaseSides.filter(side =>
        !side.includes("_blink") &&
        !normalSidebow.includes(side)
    ) || []

    return {
        blink_sidebow: blinkSidebow.length,
        normal_sidebow: normalSidebow.length,
        re_blink_embroidery_location: reBlinkEmbroideryLocation.length,
        re_normal_embroidery_location: reNormalEmbroideryLocation.length,
    }
}